{
  "es": {
    "login": {
      "acceptTos": "términos y condiciones",
      "acceptTosPrefix": "Acepto los ",
      "acceptTosRequired": "Debes aceptar los términos y condiciones para crear una cuenta.",
      "auth-ziggu/invalid-invitation-code": "Consulta con la persona que te lo compartió para ver si hay un enlace nuevo disponible. Si ya tienes una cuenta, inicia sesión en su lugar.",
      "auth-ziggu/user-created": "¡Tu cuenta de usuario se ha creado! 🎉 Estamos iniciando tu sesión, espera un momento..",
      "auth/invalid-action-code": "Por motivos de seguridad, los enlaces para restablecer la contraseña caducan al poco tiempo. Si todavía necesitas restablecer tu contraseña, puedes solicitar un nuevo correo de restablecimiento.",
      "auth/invalid-credential": "La contraseña no es válida para el correo indicado, o no existe una cuenta con ese correo.",
      "auth/invalid-email": "El correo electrónico no es válido.",
      "auth/network-request-failed": "Se ha producido un error de red. Comprueba tu conexión e inténtalo de nuevo.",
      "auth/too-many-requests": "Demasiadas solicitudes. Inténtalo de nuevo más tarde.",
      "backToLogin": "Volver a iniciar sesión",
      "cookiePolicy": "Política de cookies",
      "emailAddress": "Correo electrónico",
      "emailAddressInvalid": "Introduce un correo electrónico válido",
      "emailAddressRequired": "El correo electrónico es obligatorio",
      "googleLogin": "Iniciar sesión con Google",
      "notification_error_no_access": "Tu cuenta no tiene acceso.",
      "notification_error_session_expired": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "notification_success_logout": "Has cerrado sesión en tu cuenta.",
      "notification_success_profile_transfer": "Tu correo electrónico ha cambiado. Inicia sesión con tu nuevo correo electrónico y su contraseña.",
      "password": "Contraseña",
      "passwordConfirmMatchRequired": "La confirmación de la contraseña no coincide",
      "passwordConfirmRequired": "La confirmación de la contraseña es obligatoria",
      "passwordForgot": "¿Has olvidado tu contraseña?",
      "passwordLengthRequired": "La contraseña debe contener al menos 8 caracteres",
      "passwordRequired": "La contraseña es obligatoria",
      "password_confirm": "Confirmación de la contraseña",
      "privacyPolicy": "Política de privacidad",
      "submit_expired_reset": "Solicitar un nuevo restablecimiento de contraseña",
      "submit_expired_signup": "Volver a iniciar sesión",
      "submit_login": "Iniciar sesión",
      "submit_password_forgot": "Solicitar restablecimiento de contraseña",
      "submit_password_reset": "Restablecer contraseña",
      "submit_signup": "Crear cuenta",
      "success_password_forgot": "Si tienes una cuenta activa, hemos enviado un correo para restablecer la contraseña a {email}. Revisa tu bandeja de entrada, el enlace para restablecer la contraseña caduca en 1 hora.",
      "success_password_reset": "Contraseña restablecida correctamente. Iniciando sesión...",
      "termsandconditionsPolicy": "Términos y condiciones",
      "title_expired_reset": "Vaya, ese enlace ha caducado..",
      "title_expired_signup": "Este enlace de invitación ya no está activo",
      "title_login": "¡Bienvenido de nuevo!",
      "title_password_forgot": "¿Has olvidado tu contraseña?",
      "title_password_reset": "Restablece tu contraseña",
      "title_signup": "Completa tu registro"
    }
  }
}
